import { IOperandValue } from '../types';

export const createBasicFieldValue = (name: string): IOperandValue => ({
  __typename: 'BasicFieldValue',
  name,
  key: name,
});
